import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const rocheHorizontalCenterCss = ":host{display:flex;flex-direction:column;align-items:center}::slotted(*){display:block;margin-top:3rem;margin-left:0 !important;margin-right:0 !important}@media (min-width: 90rem){::slotted(*){margin-top:4.5rem}}::slotted(*),::slotted(*) *{box-sizing:border-box}";
const RocheHorizontalCenterStyle0 = rocheHorizontalCenterCss;

const RocheHorizontalCenter$1 = /*@__PURE__*/ proxyCustomElement(class RocheHorizontalCenter extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return (h(Host, { key: 'd394e85cd648ad421a4771088ab3a65cfba24d0d' }, h("slot", { key: '3aa91f583c77b288b1fe181da7903bf49f07e9ba' })));
    }
    static get style() { return RocheHorizontalCenterStyle0; }
}, [1, "roche-horizontal-center"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-horizontal-center"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-horizontal-center":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheHorizontalCenter$1);
            }
            break;
    } });
}

const RocheHorizontalCenter = RocheHorizontalCenter$1;
const defineCustomElement = defineCustomElement$1;

export { RocheHorizontalCenter, defineCustomElement };

//# sourceMappingURL=roche-horizontal-center.js.map